import { Translation, TranslocoService } from '@ngneat/transloco';

export function appInitializer(translocoService: TranslocoService) {
  return (): Promise<Translation | undefined> => {
    return translocoService.load('th').toPromise();
  };
}
